"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var usersList_1 = require("common/global/usersList");
var permissions_1 = require("portal/config/permissions");
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var useTitle_1 = __importDefault(require("portal/hooks/useTitle"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var usersSlice_1 = require("src/features/users/usersSlice");
var react_router_dom_1 = require("react-router-dom");
function Permissions() {
    var _a, _b;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var params = (0, react_router_dom_1.useParams)();
    var userId = params.userId;
    var docId = userId;
    //   const [docSnapshot] = useDocument(usersRef.doc(docId));
    var docData = usersList_1.globalUsersData[docId];
    var docPermissions = (_a = docData === null || docData === void 0 ? void 0 : docData.permissions) !== null && _a !== void 0 ? _a : [];
    var _c = (0, react_1.useState)(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, react_1.useState)(docPermissions), editablePermissions = _d[0], setEditableUPermissions = _d[1];
    (0, useTitle_1.default)(t("permissions.permissionsList"));
    (0, react_1.useEffect)(function () {
        setEditableUPermissions(docPermissions);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [docPermissions.length]);
    if (!docData) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var onChange = function (permissionName, checked) {
        if (checked == true) {
            if (!editablePermissions.includes(permissionName)) {
                var newPermissions = __spreadArray(__spreadArray([], editablePermissions, true), [permissionName], false);
                setEditableUPermissions(newPermissions);
            }
        }
        else {
            if (editablePermissions.includes(permissionName)) {
                var newPermissions = editablePermissions.filter(function (i) { return i !== permissionName; });
                setEditableUPermissions(newPermissions);
            }
        }
    };
    var save = function () {
        setLoading(true);
        dispatch((0, usersSlice_1.editUser)({ id: docId, permissions: editablePermissions }))
            .then(function () { return setLoading(false); })
            .then(function () {
            antd_1.message.success(t("alerts.success"));
        })
            .then(function () {
            navigate("/users/");
        });
    };
    var cancel = function () {
        history.back();
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { width: "100%", height: "100&", padding: "16px" } }, { children: [(0, jsx_runtime_1.jsx)("h2", { children: (_b = docData === null || docData === void 0 ? void 0 : docData.name) !== null && _b !== void 0 ? _b : "" }), (0, jsx_runtime_1.jsx)("div", __assign({ style: { display: "flex", flexDirection: "column" } }, { children: permissions_1.GLOBAL_PERMISSIONS.map(function (permissionName) {
                    var isChecked = editablePermissions.includes(permissionName);
                    return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: "8px" } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Checkbox, __assign({ checked: isChecked, onChange: function (e) { return onChange(permissionName, e.target.checked); } }, { children: t("permissions.".concat(permissionName)) })) }), permissionName));
                }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ style: { marginTop: "48px" } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "dashed", onClick: cancel, style: { margin: 8, marginRight: 0 } }, { children: t("common.cancel") })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", onClick: save, loading: loading, style: { margin: 8, marginRight: 0 } }, { children: t("common.save") }))] }))] })));
}
exports.default = Permissions;
